import { useEffect, useState } from 'react';
import { flushSync } from 'react-dom';

const ONE_MINUTE = 60_000;

/**
 * Returns current Date that auto-refreshes:
 * - Every minute (when tab is visible)
 * - When tab becomes visible after being hidden
 * - Right before printing (beforeprint event), via flushSync để bảo đảm
 *   DOM có giá trị mới TRƯỚC khi print dialog mở.
 */
export function useCurrentDate(): Date {
  const [date, setDate] = useState(() => new Date());

  useEffect(() => {
    const refresh = () => setDate(new Date());

    const interval = window.setInterval(() => {
      if (document.visibilityState === 'visible') refresh();
    }, ONE_MINUTE);

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') refresh();
    };

    const onBeforePrint = () => {
      flushSync(() => setDate(new Date()));
    };

    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('beforeprint', onBeforePrint);

    return () => {
      window.clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.removeEventListener('beforeprint', onBeforePrint);
    };
  }, []);

  return date;
}
